import { useState, useEffect } from 'react';
import { tenant as tenantApi, billing as billingApi } from '../services/api';



export default function Billing({ onNavigate, plan }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const ADMIN_EMAIL = 'jpatinop@gmail.com';

  useEffect(() => {
    tenantApi.getMe().then(setData);
  }, []);

  // Admin no necesita ver planes
  if (data?.email === ADMIN_EMAIL) {
    return (
      <div>
        <div className="topbar">
          <div>
            <div className="page-title">Suscripción</div>
            <div className="page-sub">Panel de administrador</div>
          </div>
        </div>
        <div className="content">
          <div className="card" style={{textAlign:'center', padding:'40px'}}>
            <div style={{fontSize:'32px', marginBottom:'16px'}}>⚙</div>
            <div style={{fontSize:'16px', fontWeight:700, marginBottom:'8px'}}>Cuenta de administrador</div>
            <div style={{fontSize:'13px', color:'var(--text2)'}}>
              Esta cuenta no requiere suscripción. Gestiona los clientes desde el panel Admin.
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleCheckout = async (plan) => {
    setLoading(true);
    const res = await billingApi.checkout(plan);
    if (res.checkout_url) {
      window.location.href = res.checkout_url;
    }
    setLoading(false);
  };

  const handleCambiarOContratar = async (planId) => {
    setLoading(true);
    if (data?.stripe_subscription_id) {
      // Ya tiene suscripción — cambiar plan
      const res = await billingApi.cambiarPlan(planId);
      if (res.status === 'ok') {
        alert(`✓ Plan cambiado a ${planId}. La diferencia se aplicará en tu próxima factura.`);
        tenantApi.getMe().then(setData);
      } else {
        alert('Error al cambiar el plan: ' + (res.detail || 'inténtalo de nuevo'));
      }
    } else {
      // Sin suscripción — ir a checkout
      const res = await billingApi.checkout(planId);
      if (res.checkout_url) window.location.href = res.checkout_url;
    }
    setLoading(false);
  };

  const handlePortal = async () => {
    setLoading(true);
    const res = await billingApi.portal();
    if (res.portal_url) {
      window.location.href = res.portal_url;
    }
    setLoading(false);
  };

  // ── Planes nuevos 3 niveles ───────────────────────────────────────────────
  const planes = [
    {
      id:       'presencia',
      nombre:   'Presencia',
      precio:   '59',
      tagline:  'Contenido IA que atrae clientes',
      features: [
        'Publicador social IA (Instagram, Facebook, LinkedIn)',
        'Plan mensual de contenido generado por IA',
        'Imágenes desde Drive o Pexels automático',
        'Programación de publicaciones sin intervención',
        'Widget de chat en tu web',
      ],
    },
    {
      id:       'conversacion',
      nombre:   'Conversación',
      precio:   '107',
      tagline:  'El contenido atrae, el agente convierte',
      featured: true,
      features: [
        'Todo lo del Plan Presencia',
        'Agente IA en WhatsApp Business',
        'Agente IA en widget web',
        'Agenda citas con Google Calendar',
        'Respuesta a audios de WhatsApp (Whisper)',
        'Anti-duplicados y RGPD incluido',
      ],
    },
    {
      id:       'autonomo',
      nombre:   'Autónomo',
      precio:   '174',
      tagline:  'Publica, atiende y agenda solo',
      features: [
        'Todo lo del Plan Conversación',
        'Agente unificado Web + WhatsApp',
        'Posts ilimitados con IA',
        'Catálogo e inventario integrado con IA',
        'Historial completo y panel de análisis',
      ],
    },
  ];

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Suscripción</div>
          <div className="page-sub">Plan y facturación</div>
        </div>
      </div>

      <div className="content">

        {/* ── Planes nuevos ── */}
        <div className="plans-grid">
          {planes.map(p => {
            const isCurrent = data?.plan === p.id || data?.plan === p.id + '_anual';
            return (
              <div key={p.id} className={`plan-card ${isCurrent ? 'current' : ''}`}
                style={p.featured ? { border: '1px solid var(--purple)', position: 'relative' } : {}}>
                {p.featured && (
                  <div style={{
                    position: 'absolute', top: -11, left: '50%', transform: 'translateX(-50%)',
                    background: 'var(--purple)', color: '#fff',
                    fontSize: 10, fontWeight: 700, padding: '3px 14px', borderRadius: 99,
                    whiteSpace: 'nowrap', letterSpacing: '.05em',
                  }}>
                    MÁS POPULAR
                  </div>
                )}
                {isCurrent && <div className="plan-badge">ACTUAL</div>}
                <div className="plan-name">{p.nombre}</div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12 }}>{p.tagline}</div>
                <div className="plan-price">€{p.precio}</div>
                <div className="plan-period">/mes · IVA incl.</div>
                {p.features.map((f, i) => (
                  <div key={i} className="plan-feature">{f}</div>
                ))}
                <div style={{marginTop:'14px'}}>
                  {isCurrent ? (
                    <button className="btn btn-ghost"
                      style={{width:'100%', justifyContent:'center', fontSize:'11px', opacity:0.5, cursor:'default'}}>
                      Plan actual
                    </button>
                  ) : (
                    <button className="btn btn-primary"
                      style={{width:'100%', justifyContent:'center', fontSize:'11px'}}
                      onClick={() => handleCambiarOContratar(p.id)}
                      disabled={loading}>
                      {loading ? 'Redirigiendo...' : 'Seleccionar plan'}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* ── Planes anuales ── */}
        <div className="card" style={{marginTop: 20}}>
          <div className="card-title">💰 Planes anuales — 1 mes gratis</div>
          <div style={{fontSize:12, color:'var(--text2)', marginBottom:16, lineHeight:1.6}}>
            Ahorra el equivalente a un mes pagando anualmente. Mismo plan, sin permanencia forzada.
          </div>
          <div style={{display:'flex', gap:10, flexWrap:'wrap'}}>
            {[
              { id: 'presencia_anual',    label: 'Presencia Anual',    precio: '648€/año' },
              { id: 'conversacion_anual', label: 'Conversación Anual', precio: '1.176€/año' },
              { id: 'autonomo_anual',     label: 'Autónomo Anual',     precio: '1.920€/año' },
            ].map(pa => {
              const isCurrent = data?.plan === pa.id;
              return (
                <button key={pa.id}
                  className={`btn ${isCurrent ? 'btn-ghost' : 'btn-ghost'}`}
                  style={{fontSize:11, opacity: isCurrent ? 0.5 : 1, cursor: isCurrent ? 'default' : 'pointer'}}
                  onClick={() => !isCurrent && handleCambiarOContratar(pa.id)}
                  disabled={loading || isCurrent}>
                  {isCurrent ? '✓ ' : ''}{pa.label} · {pa.precio}
                </button>
              );
            })}
          </div>
        </div>

        <div className="two-col" style={{marginTop: 20}}>
          {/* ── Configuración WhatsApp ── */}
          <div className="card">
            <div className="card-title">Configuración WhatsApp (servicio único)</div>
            <div style={{marginBottom:'12px', fontSize:'12px', color:'var(--text2)'}}>
              ¿No sabes configurar WhatsApp? Nosotros lo hacemos por ti.
            </div>
            <div style={{display:'flex', alignItems:'baseline', gap:'8px', marginBottom:'16px'}}>
              <span style={{fontFamily:'var(--font-display)', fontSize:'28px', fontWeight:700, color:'var(--text)'}}>€181,50</span>
              <span style={{fontSize:'12px', color:'var(--text3)'}}>pago único · IVA incl.</span>
            </div>
            <button className="btn btn-ghost" style={{fontSize:'11px'}}
              onClick={() => handleCheckout('config_wp')}
              disabled={loading}>
              Contratar configuración
            </button>
          </div>

          {/* ── Portal de facturación ── */}
          <div className="card">
            <div className="card-title">Gestionar suscripción</div>
            <div style={{fontSize:'12px', color:'var(--text2)', marginBottom:'16px'}}>
              Cambia tu tarjeta, descarga facturas o cancela tu plan desde el portal de Stripe.
            </div>
            <button className="btn btn-ghost" style={{fontSize:'11px'}}
              onClick={handlePortal}
              disabled={loading || !data?.stripe_customer_id}>
              → Abrir portal de facturación
            </button>
            {!data?.stripe_customer_id && (
              <div style={{marginTop:'8px', fontSize:'11px', color:'var(--text3)'}}>
                Selecciona un plan primero para acceder al portal.
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}